import HeaderMain from "../components/header/HeaderMain";
import NavMain from "../components/nav/NavMain";
import ReportLoansOutstandingBalanceSheet from "../reports/ReportLoansOutstandingBalanceSheet";


function LoansOutstandingBalanceSheet() {
    return (
        <>
            <NavMain slug="loans-outstanding-balance-sheet" parent="3" />
            <HeaderMain slug="loans-outstanding-balance-sheet" />
            <div className="main-content">
                <ReportLoansOutstandingBalanceSheet />
            </div>
        </>
    );
}

export default LoansOutstandingBalanceSheet;